module.exports = __webpack_public_path__ + "static/media/presentación.70710ade.png";